<div class="gascalc m-10">
    <h3 class="content-title">RPECalculator</h3>
    <div class="content">

        <p>Companion to Sutton, Biblarz, and Morehart “Rocket Propulsion Elements”, 10th Edition</p>

        <p>The isentropic flow relations that describe nozzle flow under various gas dynamic conditions in Chapter 3 are obtainable here.  
            The calculator's section giving oblique shock results has the normal shock formulations built in. 
            Fanno and Rayleigh calculations are limited to constant area ducts. 
            With the RPE Book Calculator the user avoids the need to use tables which normally require interpolation or extrapolation, and further manipulations needed to arrive at the desired final answers are easily done with any standard calculators. 
            In addition to being a labor-saving aid enables the user to conveniently tackle problems using actual values of k (as long as they remain constant in the flow) without defaulting to 1.40.  
            The section on "Two-stage Rocket Flight" relates to Chapter 4 and is limited to transit in gravity-free drag-free space and calculates optimum stage propellant loadings for a given total change in vehicle speed with a given either total rocket mass or payload mass.  
        </p>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Isentropic Flow Parameters
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <app-if-section></app-if-section>
                
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Normal-Shock Parameters 
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <rpe-nstab></rpe-nstab>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Oblique Shock 
                    </mat-panel-title>
                </mat-expansion-panel-header>  

                <mat-tab-group [@.disabled]="true">
                    <mat-tab>
                        <ng-template mat-tab-label>
                            Deflection angle δ (weak shock)
                        </ng-template>
                        <ng-template matTabContent>
                            <deflect-weak></deflect-weak>
                        </ng-template>
                    </mat-tab>

                    <mat-tab>
                        <ng-template mat-tab-label>
                            Deflection angle δ (strong shock)
                        </ng-template>
                        <ng-template matTabContent>
                            <deflect-strong></deflect-strong>
                        </ng-template>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            Shock angle θ
                        </ng-template>
                        <ng-template matTabContent>
                            <shock-angle></shock-angle>
                        </ng-template>
                    </mat-tab>

                </mat-tab-group>

            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Fanno Flow 
                    </mat-panel-title>
                </mat-expansion-panel-header>  
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Rayleigh Flow 
                    </mat-panel-title>
                </mat-expansion-panel-header>  
            </mat-expansion-panel>

            

        </mat-accordion>
    </div>
</div>